exports.keyboardsList = [
  {
    label: "1",
    descr: ""
  },
  {
    label: "2",
    descr: "ABC"
  },
  {
    label: "3",
    descr: "DEF"
  },
  {
    label: "4",
    descr: "GHI"
  },
  {
    label: "5",
    descr: "JKL"
  },
  {
    label: "6",
    descr: "MNO"
  },
  {
    label: "7",
    descr: "PQRS"
  },
  {
    label: "8",
    descr: "TUV"
  },
  {
    label: "9",
    descr: "WXYZ"
  },
  {
    label: "*",
    descr: ""
  },
  {
    label: "0",
    descr: ""
  },
  {
    label: "#",
    descr: ""
  }
]